const GA_SCRIPT_ID = "ga-tracker";
const loadGAScript = (trackingId) => {
  if (document.getElementById(GA_SCRIPT_ID)) {
    console.log("[GA] Script already loaded.");
    return;
  }

  console.log(`[GA] Injecting script for tracking ID: ${trackingId}`);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
  script.id = GA_SCRIPT_ID;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag("js", new Date());
  gtag("config", trackingId);

  console.log("[GA] Google Analytics initialized.");
};

export const initiateGoogleAnalytics = (ga) => {
  try {
    console.log("ga", ga);
    if (ga) {
      if (ga?.enabled && ga?.config?.trackingId) {
        console.log("[GA] Config found and enabled. Loading GA...");
        loadGAScript(ga.config.trackingId);
      } else {
        console.log("[GA] Not enabled or tracking ID missing.");
      }
    } else {
      console.warn("No doc for [GA]");
    }
  } catch (err) {
    console.warn("Failed to load Google Analytics:", err);
  }
};
